import {
  Card,
  Grid,
  Stack,
  Typography,
} from "@compass/core";
import { ModelPropertyBase } from "generated/openApi";

import "moment-timezone";

export const AprEtsTabF = (props: {
  properties: ModelPropertyBase[] | undefined;
}) => {

  return (
    <Card style={{ height: "100%" }}>
      <Stack spacing="sm" style={{ height: "100%" }}>
        <Typography variant="h5">Veterans Served</Typography>
        <Grid container spacing="lg">
        </Grid>
      </Stack>
    </Card>
  );
};
